import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { FOCUS_SEARCH_INPUT_STATE } from "../../../../../app/src/Utils/Constants";

const DEBOUNCE_MS = 400;

// Único punto de debounce de la búsqueda (contrato §0 "Cancelar peticiones. Con debounce de
// 400 ms..."). BuscarPage no debe añadir un segundo debounce: reacciona directamente a los
// cambios de `urlState.text`, que ya llegan espaciados desde aquí.
const SearchInput = ({ value, onChange }) => {
  const { t } = useTranslation();
  const [text, setText] = useState(value || "");
  const timeoutRef = useRef(null);
  const inputRef = useRef(null);
  const location = useLocation();
  const history = useHistory();
  const isFirstRunRef = useRef(true);

  useEffect(() => {
    setText(value || "");
  }, [value]);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  // Se enfoca el campo para poder escribir directamente al llegar a /buscar desde la propia app
  // (lupa, entradas del menú como "Descubre", redirecciones...). No se enfoca al cargar la página
  // directamente, al recargar ni con atrás/adelante, para no abrir el teclado en móvil sin pedirlo.
  // La lupa manda además FOCUS_SEARCH_INPUT_STATE para volver a enfocar si ya estábamos en /buscar;
  // se depende de `location.key` porque cada clic es una navegación nueva aunque la ruta sea la misma.
  // POP (carga directa, recarga, atrás/adelante) nunca enfoca, aunque la entrada del historial
  // conserve el estado de la lupa.
  useEffect(() => {
    const isAppNavigation = history.action !== "POP";
    if (isAppNavigation && (isFirstRunRef.current || location.state?.[FOCUS_SEARCH_INPUT_STATE])) {
      inputRef.current?.focus();
    }
    isFirstRunRef.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);

  const handleChange = (e) => {
    const next = e.target.value;
    setText(next);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => onChange(next), DEBOUNCE_MS);
  };

  return (
    <div className="bq-search-input">
      <svg width="22" height="22" viewBox="0 0 24 24" className="bq-icon" aria-hidden="true">
        <circle cx="10.5" cy="10.5" r="7" />
        <line x1="15.5" y1="15.5" x2="21" y2="21" />
      </svg>
      <input
        ref={inputRef}
        type="text"
        aria-label={t("search.open.aria")}
        placeholder={t("search.buscar.placeholder")}
        value={text}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchInput;
